import { connect, type FormikContextType } from 'formik';
import { useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';

interface IFormikEffectProps {
  onEffect: () => void;
}

const FormikEffect = ({
  formik,
  onEffect,
}: IFormikEffectProps & { formik: FormikContextType<unknown> }) => {
  const prevValuesRef = useRef<unknown>(null);

  useEffect(() => {
    if (!isEqual(prevValuesRef.current, formik.values)) {
      if (prevValuesRef.current) {
        onEffect();
      }
      prevValuesRef.current = formik.values;
    }
  }, [formik.values, onEffect]);
  return null;
};
export default connect<IFormikEffectProps, unknown>(FormikEffect);
